import { api } from './client';

export interface UserDto {
  id: string;
  email: string;
  name?: string;
  role: string;
  tenantId: string;
  isSuperAdmin: boolean;
  emailVerifiedAt: string | null;
  createdAt: string;
}

export interface AuthResponse {
  user: UserDto;
  accessToken: string;
}

export const authApi = {
  login: (email: string, password: string) =>
    api.post<AuthResponse>('/auth/login', { email, password }),

  register: (data: { email: string; password: string; name: string; companyName: string; gstin?: string }) =>
    api.post<AuthResponse>('/auth/register', data),

  me: () => api.get<UserDto>('/auth/me'),

  logout: () => api.post<void>('/auth/logout', {}),

  forgotPassword: (email: string) => api.post<{ message: string }>('/auth/forgot-password', { email }),

  resetPassword: (token: string, newPassword: string) =>
    api.post<{ message: string }>('/auth/reset-password', { token, newPassword }),

  verifyEmail: (token: string) => api.post<{ message: string }>('/auth/verify-email', { token }),

  resendVerification: () => api.post<{ message: string }>('/auth/resend-verification', {}),
};
